import { render, staticRenderFns } from "./OrdenVenta.vue?vue&type=template&id=539d0dd0&scoped=true&"
import script from "./OrdenVenta.vue?vue&type=script&lang=js&"
export * from "./OrdenVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d0dd0",
  null
  
)

export default component.exports